import { useDebugStore } from '../../stores/debugStore'
import { useCallback } from 'react'
import { useIntlayer } from 'react-intlayer'

export const ActionLogger = () => {
  const intl = useIntlayer('actionLogger')
  const actionHistory = useDebugStore((state) => state.actionHistory)
  const clearHistory = useDebugStore((state) => state.clearHistory)
  const isEnabled = useDebugStore((state) => state.isEnabled)
  const toggleDebug = useDebugStore((state) => state.toggleDebug)

  const handleActionClick = useCallback((action: any) => {
    console.group(`🎯 Action: ${action.action}`)
    console.log('Timestamp:', new Date(action.timestamp).toLocaleTimeString())
    console.log('Action ID:', action.id)
    console.log('Payload:', action.payload)
    console.log('State snapshot:', action.state)
    console.groupEnd()
  }, [])

  return (
    <div className="bg-gray-800 rounded p-3 mb-4">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-semibold text-yellow-300 text-sm">{intl.title}</h4>
        <div className="flex gap-2">
          <button
            onClick={toggleDebug}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              isEnabled
                ? 'bg-green-600 hover:bg-green-500 text-white'
                : 'bg-gray-600 hover:bg-gray-500 text-gray-300'
            }`}
          >
            {isEnabled ? intl.enabled : intl.disabled}
          </button>
          <button
            onClick={clearHistory}
            className="px-2 py-1 bg-red-600 hover:bg-red-500 text-white text-xs rounded transition-colors"
          >
            {intl.clear}
          </button>
        </div>
      </div>

      <div className="max-h-64 overflow-y-auto space-y-1">
        {actionHistory.length === 0 ? (
          <div className="text-gray-400 text-xs text-center py-4">{intl.noActions}</div>
        ) : (
          actionHistory.map((action) => (
            <button
              key={action.id}
              onClick={() => handleActionClick(action)}
              className="w-full text-left px-2 py-1 bg-gray-700 hover:bg-gray-600 rounded text-xs transition-colors"
            >
              <div className="flex justify-between items-center">
                <span className="text-blue-300 font-mono">{action.action}</span>
                <span className="text-gray-400">
                  {new Date(action.timestamp).toLocaleTimeString()}
                </span>
              </div>
              {action.payload.elementId && (
                <div className="text-gray-400 truncate">ID: {action.payload.elementId}</div>
              )}
            </button>
          ))
        )}
      </div>
    </div>
  )
}
